import React from 'react';
import Box from '@mui/material/Box';

const TONES = {
    success: { color: '#067647', bg: '#ECFDF3', border: '#ABEFC6', dot: '#17B26A' },
    error: { color: '#B42318', bg: '#FEF3F2', border: '#FECDCA', dot: '#F04438' },
    warning: { color: '#B54708', bg: '#FFFAEB', border: '#FEDF89', dot: '#F79009' },
    info: { color: '#175CD3', bg: '#EFF8FF', border: '#B2DDFF', dot: '#2E90FA' },
    neutral: { color: '#344054', bg: '#F9FAFB', border: '#EAECF0', dot: '#98A2B3' },
};

/** Etiqueta de status discreta, com ponto indicador + texto (nunca só cor). */
export default function StatusChip({ label, tone = 'neutral', sx }) {
    const t = TONES[tone] || TONES.neutral;

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1,
                py: 0.25,
                borderRadius: 1.5,
                border: `1px solid ${t.border}`,
                bgcolor: t.bg,
                color: t.color,
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: 1.6,
                whiteSpace: 'nowrap',
                ...sx,
            }}
        >
            <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: t.dot, flexShrink: 0 }} />
            {label}
        </Box>
    );
}
